import * as React from 'react'
import {cva, type VariantProps} from 'class-variance-authority'
import {LoaderCircle} from 'lucide-react'

import {cn} from '@/shared/lib/cn'

const spinnerVariants = cva('animate-spin text-muted-foreground', {
  variants: {
    size: {
      small: 'size-6',
      medium: 'size-10',
      large: 'size-14',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
})

function Spinner({
  size,
  className,
  ...props
}: React.ComponentProps<'svg'> & VariantProps<typeof spinnerVariants>) {
  return (
    <LoaderCircle
      className={cn(spinnerVariants({size}), className)}
      role="status"
      aria-label="Загрузка"
      {...props}
    />
  )
}

export {Spinner, spinnerVariants}
